/**
 * Modulo para los tipos
 */
import TiposUniGesActionsService from "./tiposUniGesActionsService";
import TiposUniGesGridAngCtrl from "./tiposUniGesGridCtrl";
import angular from 'angular';
import ngResourceModuleName from 'angular-resource';

const TiposUniGesModule = angular
    .module('tiposUniGes', ['app', ngResourceModuleName])
    .factory('TiposUniGesActionsService', TiposUniGesActionsService)
    .controller('TiposUniGesGridAngCtrl', TiposUniGesGridAngCtrl)
;
export default TiposUniGesModule;